import React from "react";
import Select from "react-select";

/**
 * Search controls are kept separate from the result grid so input rules,
 * labels, and submit behaviour have one small, testable home.
 *
 * Pokemon names and collector numbers are both alphanumeric in the real
 * catalogue (Porygon2, SVP001, TG05/TG30), so neither field sanitizes what the
 * user types. Normalization belongs at the request boundary, not in an input.
 *
 * It is a form so Enter searches; it is otherwise the plain row of controls it
 * always was — a heading and per-field labels were tried and read as clutter.
 */
export default function SearchForm({
  cardName,
  setCardName,
  cardNumber,
  setCardNumber,
  onSearch,
  onToggleBulk,
  showBulk,
  setOptions,
  selectedOptions,
  onSelectSets,
}) {
  return (
    <form className="search-form" onSubmit={(event) => { event.preventDefault(); onSearch(); }}>
      <div className="search-row">
        <input
          type="search"
          className="search-input"
          aria-label="Card name"
          placeholder="Card name (e.g., Charizard ex)"
          value={cardName}
          onChange={(event) => setCardName(event.target.value)}
          autoComplete="off"
        />
        <input
          type="search"
          className="search-input search-input--number"
          aria-label="Card number"
          placeholder="Card # (optional)"
          value={cardNumber}
          onChange={(event) => setCardNumber(event.target.value)}
          autoComplete="off"
        />
        <button type="submit" className="btn btn-primary">Search</button>
        <button type="button" className="btn btn-secondary" onClick={onToggleBulk}>
          {showBulk ? "Close bulk add" : "Bulk Add"}
        </button>
      </div>

      <div className="set-filter-row">
        <label htmlFor="setFilter">Sets:</label>
        <div className="set-filter-control">
          <Select
            inputId="setFilter"
            options={setOptions}
            value={selectedOptions}
            onChange={(opts) => onSelectSets(Array.isArray(opts) ? opts.map((option) => option.value) : [])}
            placeholder="All Sets"
            isClearable
            isSearchable
            isMulti
            classNamePrefix="rs"
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            menuPortalTarget={document.body}
          />
        </div>
      </div>
    </form>
  );
}
